export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-r from-primary-50/50 via-background-50 to-accent-50/30 rounded-2xl p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              移动端观影
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[500px]">
              天堂影视移动端适配手机和平板，随时随地打开浏览器即可观看高清电影。支持横竖屏切换，夜间模式护眼观影，流量优化播放不耗流量，在路上也能畅享影院级观影体验。
            </p>
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 text-sm font-medium flex items-center gap-2 whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill"></i>
                iOS 网页版
              </div>
              <div className="px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 text-sm font-medium flex items-center gap-2 whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill"></i>
                Android 网页版
              </div>
            </div>
          </div>
          <div className="w-full max-w-[320px]">
            <div className="relative mx-auto w-[220px] h-[380px] rounded-[28px] border-[3px] border-foreground-800 bg-foreground-900 overflow-hidden">
              <div className="absolute top-0 left-0 right-0 h-7 bg-foreground-800 flex items-center justify-center">
                <div className="w-16 h-1 rounded-full bg-foreground-600"></div>
              </div>
              <div className="mt-7 p-3">
                <div className="w-full h-36 rounded-lg bg-gradient-to-br from-primary-500/80 to-accent-500/80 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-4xl text-background-50/80"></i>
                </div>
                <div className="mt-3 space-y-1.5">
                  <div className="w-full h-2.5 rounded bg-background-300/60"></div>
                  <div className="w-3/4 h-2.5 rounded bg-background-300/40"></div>
                </div>
                <div className="mt-4 space-y-2">
                  {[1, 2, 3].map((n) => (
                    <div key={n} className="flex items-center gap-2">
                      <div className="w-10 h-10 rounded bg-background-300/40 flex-shrink-0"></div>
                      <div className="flex-1 space-y-1">
                        <div className="w-2/3 h-2 rounded bg-background-300/50"></div>
                        <div className="w-1/2 h-1.5 rounded bg-background-300/30"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}